/**
 * Kare-pipeline: kayitli sistemleri faz sirasina gore calistirir.
 *
 * `run(ctx, phases)` yalnizca verilen fazlari yurutur; bu sayede Engine,
 * fazlar arasina kendi isini (profiling gauge'lari gibi) yerlestirebilir
 * (or. structural gauge renderTargets ile render arasinda).
 *
 * Profiling: bir sistemin faz metodu yalnizca `labels[phase]` tanimliysa
 * `engineProfiling.phase(label, ...)` ile sarilir; aksi halde dogrudan
 * cagrilir (eski davranis paritesi: profillenmemis adimlar profillenmez).
 */
import { engineProfiling } from "../EngineProfiling";
import type { EngineSystem, FrameContext, FramePhase } from "./EngineSystem";

const ALL_PHASES: readonly FramePhase[] = [
  "sync",
  "begin",
  "update",
  "beforeRender",
  "renderTargets",
  "render",
  "afterRender",
];

export class FramePipeline {
  private readonly _systems: EngineSystem[] = [];

  /** Sistemi kayit eder ve init kancasini calistirir. Kayit sirasi = calisma sirasi. */
  register(engine: FrameContext["engine"], system: EngineSystem): void {
    this._systems.push(system);
    system.init?.(engine);
  }

  /** Verilen fazlari (varsayilan: tumu) kayit sirasinda calistirir. */
  run(ctx: FrameContext, phases: readonly FramePhase[] = ALL_PHASES): void {
    for (const phase of phases) {
      for (const sys of this._systems) {
        const fn = sys[phase] as ((c: FrameContext) => void) | undefined;
        if (!fn) continue;
        const label = sys.labels?.[phase];
        if (label) engineProfiling.phase(label, () => fn.call(sys, ctx));
        else fn.call(sys, ctx);
      }
    }
  }

  dispose(): void {
    for (const sys of this._systems) sys.dispose?.();
    this._systems.length = 0;
  }
}
